<template>
  <div>
   <div class="grid-row">
      <div class="titulo-grid"
        v-b-toggle.collapse-1
        variant="primary"
        clickable
        @click="handleFichaTecnicaAdocao"
      >
        Adoção
        <!-- <i class="mdn-Icon-baixo mdn-Icon  when-closed btn-rounded-xs mdn-Button--global"
          v-if="dadosAdocao" />
        <i class="mdn-Icon-cima mdn-Icon  when-open btn-rounded-xs mdn-Button--global"
          v-if="dadosAdocao" /> -->

        <SGPIconComponent
          icon="mdi-chevron-down-circle"
          class="when-closed float-right"
          color="#444444"
          v-if="dadosAdocao"
        />
       
        <SGPIconComponent
          icon="mdi-chevron-up-circle"
          class="when-open float-right"
          color="#444444"
          v-if="dadosAdocao"
        />
      </div>
    </div>
    <template v-if="Object.keys(dadosAdocao).length">
      <b-collapse id="collapse-1" class="mt-0">
        <div class="grid-row">
          <div class="titulo">
            Razão Social
          </div>
          <div class="">
            {{ dadosAdocao.razao_social.toUpperCase() }}
          </div>
          <div class="titulo">
            Tipo de Serviço
          </div>
          <div class="">
          <span v-if="dadosAdocao.sdwan">
            {{ dadosAdocao.sdwan.toUpperCase() }}
          </span>
            <span v-else>-</span>
          </div>
        </div>
        <div class="grid-row">
          <div class="titulo">
            Número da OE
          </div>
          <div class="">
          <span v-if="dadosAdocao.numero_oe">
            {{ dadosAdocao.numero_oe.toUpperCase() }}
          </span>
            <span v-else>-</span>
          </div>
          <div class="titulo">
            Ativa/Desativa
          </div>
          <div class="">
          <span v-if="dadosAdocao.atv_des">
            {{ dadosAdocao.atv_des.toUpperCase() }}
          </span>
            <span v-else>-</span>
          </div>
        </div>
        <div class="grid-row">
          <div class="titulo">
            CNL Ponta A
          </div>
          <div class="">
          <span v-if="dadosAdocao.cnl_ponta_a">
            {{ dadosAdocao.cnl_ponta_a.toUpperCase() }}
          </span>
            <span v-else>-</span>
          </div>
          <div class="titulo">
            Número OTS Ponta A
          </div>
          <div class="">
          <span v-if="dadosAdocao.numero_ots_ponta_a">
            {{ dadosAdocao.numero_ots_ponta_a }}
          </span>
            <span v-else>-</span>
          </div>
        </div>
        <div class="grid-row">
          <div class="titulo">
            CNL Ponta B
          </div>
          <div class="">
          <span v-if="dadosAdocao.cnl_ponta_b">
            {{ dadosAdocao.cnl_ponta_b.toUpperCase() }}
          </span>
            <span v-else>-</span>
          </div>
          <div class="titulo">
            Número OTS Ponta B
          </div>
          <div class="">
          <span v-if="dadosAdocao.numero_ots_ponta_b">
            {{ dadosAdocao.numero_ots_ponta_b }}
          </span>
            <span v-else>-</span>
          </div>
        </div>
        <div class="grid-row">
          <div class="titulo">
            Tipo Acesso
          </div>
          <div class="">
          <span v-if="dadosAdocao.facilidade_viabilidade">
            {{ dadosAdocao.facilidade_viabilidade.toUpperCase() }}
          </span>
            <span v-else>-</span>
          </div>
          <!-- Comentado campo Delta - PBI-9757 - Até estruturação de todos os campos  -->
          <!-- <div class="titulo">
            Delta
          </div>
          <div class="">
          <span v-if="dadosAdocao.delta">
            {{ dadosAdocao.delta }}
          </span>
            <span v-else>-</span>
          </div> -->
          <div class="titulo">
            Código SAP
          </div>
          <div class="">
          <span v-if="dadosAdocao.codigo_sap">
            {{ dadosAdocao.codigo_sap }}
          </span>
            <span v-else>-</span>
          </div>
        </div>
        <div class="grid-row">
          <div class="titulo">
            Contrato Dados
          </div>
          <div class="">
          <span v-if="dadosAdocao.contrato">
            {{ dadosAdocao.contrato.toUpperCase() }}
          </span>
            <span v-else>-</span>
          </div>
          <div class="titulo">
            Contrato Voz
          </div>
          <div class="">
          <span v-if="dadosAdocao.contrato_voz">
            {{ dadosAdocao.contrato_voz.toUpperCase() }}
          </span>
            <span v-else>-</span>
          </div>
        </div>
        <div class="grid-row">
          <div class="titulo">
            Número SEV
          </div>
          <div class="">
          <span v-if="dadosAdocao.numero_sev">
            {{ dadosAdocao.numero_sev }}
          </span>
            <span v-else>-</span>
          </div>
          <div class="">
           
          </div>
          <div class="">
            <span ></span>
          </div>
          <!-- <div class="titulo">
            Tipo Acesso
          </div>
          <div class="">
          <span v-if="dadosAdocao.facilidade_viabilidade">
            {{ dadosAdocao.facilidade_viabilidade.toUpperCase() }}
          </span>
            <span v-else>-</span>
          </div> -->
        </div>
        <div>
          <div class="grid-row my-1" v-if="dadosAdocao.historico">
            <div class="-3 titulo">
              Histórico
            </div>
            <div class="-9">
              <span v-html="dadosAdocao.historico"></span>
            </div>
          </div>
        </div>
        <div class="grid-row">
          <div class="titulo">
            Ponta A - Endereço
          </div>
          <div class="">
          <span v-if="dadosAdocao.pco_circuito[0] && dadosAdocao.pco_circuito[0].endereco">
            {{ dadosAdocao.pco_circuito[0].endereco.toUpperCase() }}
          </span>
            <span v-else>-</span>
          </div>
          <div class="titulo">
            Ponta B - Endereço
          </div>
          <div class="">
          <span v-if="dadosAdocao.pco_circuito[1] && dadosAdocao.pco_circuito[1].endereco">
            {{ dadosAdocao.pco_circuito[1].endereco.toUpperCase() }}
          </span>
            <span v-else>-</span>
          </div>
        </div>
        <div class="grid-row">
          <div class="titulo">
            Ponta A - Bairro
          </div>
          <div class="">
          <span v-if="dadosAdocao.pco_circuito[0] && dadosAdocao.pco_circuito[0].bairro">
            {{ dadosAdocao.pco_circuito[0].bairro.toUpperCase() }}
          </span>
            <span v-else>-</span>
          </div>
          <div class="titulo">
            Ponta B - Bairro
          </div>
          <div class="">
          <span v-if="dadosAdocao.pco_circuito[1] && dadosAdocao.pco_circuito[1].bairro">
            {{ dadosAdocao.pco_circuito[1].bairro.toUpperCase() }}
          </span>
            <span v-else>-</span>
          </div>
        </div>
        <div class="grid-row">
          <div class="titulo">
            Ponta A - Complemento
          </div>
          <div class="">
          <span v-if="dadosAdocao.pco_circuito[0] && dadosAdocao.pco_circuito[0].complemento">
            {{ dadosAdocao.pco_circuito[0].complemento.toUpperCase() }}
          </span>
            <span v-else>-</span>
          </div>
          <div class="titulo">
            Ponta B - Complemento
          </div>
          <div class="">
          <span v-if="dadosAdocao.pco_circuito[1] && dadosAdocao.pco_circuito[1].complemento">
            {{ dadosAdocao.pco_circuito[1].complemento.toUpperCase() }}
          </span>
            <span v-else>-</span>
          </div>
        </div>
        <div class="grid-row">
          <div class="titulo">
            Ponta A - Número
          </div>
          <div class="">
          <span v-if="dadosAdocao.pco_circuito[0] && dadosAdocao.pco_circuito[0].numero">
            {{ dadosAdocao.pco_circuito[0].numero.toUpperCase() }}
          </span>
            <span v-else>-</span>
          </div>
          <div class="titulo">
            Ponta B - Número
          </div>
          <div class="">
          <span v-if="dadosAdocao.pco_circuito[1] && dadosAdocao.pco_circuito[1].numero">
            {{ dadosAdocao.pco_circuito[1].numero.toUpperCase() }}
          </span>
            <span v-else>-</span>
          </div>
        </div>
        <div class="grid-row">
          <div class="titulo">
            Ponta A - Cidade
          </div>
          <div class="">
          <span v-if="dadosAdocao.pco_circuito[0] && dadosAdocao.pco_circuito[0].cidade">
            {{ dadosAdocao.pco_circuito[0].cidade.toUpperCase() }}
          </span>
            <span v-else>-</span>
          </div>
          <div class="titulo">
            Ponta B - Cidade
          </div>
          <div class="">
          <span v-if="dadosAdocao.pco_circuito[1] && dadosAdocao.pco_circuito[1].cidade">
            {{ dadosAdocao.pco_circuito[1].cidade.toUpperCase() }}
          </span>
            <span v-else>-</span>
          </div>
        </div>
        <div class="grid-row">
          <div class="titulo">
            Ponta A - UF
          </div>
          <div class="">
          <span v-if="dadosAdocao.pco_circuito[0] && dadosAdocao.pco_circuito[0].uf">
            {{ dadosAdocao.pco_circuito[0].uf.toUpperCase() }}
          </span>
            <span v-else>-</span>
          </div>
          <div class="titulo">
            Ponta B - UF
          </div>
          <div class="">
          <span v-if="dadosAdocao.pco_circuito[1] && dadosAdocao.pco_circuito[1].uf">
            {{ dadosAdocao.pco_circuito[1].uf.toUpperCase() }}
          </span>
            <span v-else>-</span>
          </div>
        </div>
        <div class="grid-row">
          <div class="titulo">
            Ponta A - CNL
          </div>
          <div class="">
          <span v-if="dadosAdocao.pco_circuito[0] && dadosAdocao.pco_circuito[0].cnl">
            {{ dadosAdocao.pco_circuito[0].cnl.toUpperCase() }}
          </span>
            <span v-else>-</span>
          </div>
          <div class="titulo">
            Ponta B - CNL
          </div>
          <div class="">
          <span v-if="dadosAdocao.pco_circuito[1] && dadosAdocao.pco_circuito[1].cnl">
            {{ dadosAdocao.pco_circuito[1].cnl.toUpperCase() }}
          </span>
            <span v-else>-</span>
          </div>
        </div>               
      </b-collapse>
    </template>
    <!-- <template v-else>
      <div class="grid-row">
        <div class="-3 titulo">
          Histórico adoção
        </div>
        <div class="bg-warning">
          Não foram encontrados dados da adoção
        </div>
      </div>
  </template> -->
 </div>  
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import criarToast from '@/common/boot/ToastsHandler'

export default {
  name: "FichaPcoCircuitoComponent",
  props: {
    dadosFichaTecnica: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      isCollapsed: false,
      pco_circuito: { ...this.dadosFichaTecnica.pco_tarefa.pco_circuito }
    }
  },

  computed: {
    ...mapGetters('fichaTecnicaWorkflow', [
      'dadosAdocao'
    ])
  },

  methods: {
    ...mapActions('fichaTecnicaWorkflow', [
      'listaDadosFichaTecnicaAdocao'
    ]),
    handleFichaTecnicaAdocao () {
      if(!this.pco_circuito.pco_circuito_adocao_id) {
        criarToast({
          tipo: 'error',
          mensagem: 'Não há dados do circuito adoção.'
        })

        return 
      }

      const hasDadosAdocao = Object.keys(this.dadosAdocao).length > 0

      if (!hasDadosAdocao) {
        this.listaDadosFichaTecnicaAdocao(parseInt(this.pco_circuito.pco_circuito_adocao_id))
      }

      this.isCollapsed = !this.isCollapsed
      
    }
  }
  
}
</script>